import { invalid } from "moment";

export const validationMessages = {
    email: {
        required : "Please provide email",
        invalid : "Please provide valid email",
    },
    phone: {
        required : "Please provide phone",
        invalid : "Please provide valid phone",
    },
    firstName: {
        required : "Please provide  first name",
        invalid : "Please provide valid first name",
    },
    financialYear: {
        required : "Please provide a year",
        invalid : "Please provide a valid year",
    },
    categoryName: {
        required : "Please provide a category name",
        invalid : "Please provide a valid category name",
    },

    subCategoryName: {
        required : "Please provide a  sub category name",
        invalid : "Please provide a valid sub category name",
    },
    lastName: {
        required : "Please provide last name",
        invalid : "Please provide valid last name",
    },
    title: {
        required : "Please provide title", 
    },
    whatsappNumber: {
        required : "Please provide whatsapp number", 
        invalid : "Please provide valid whatsapp number", 
    },
    reference: {
        required : "Please provide reference name", 
        invalid : "Please provide valid reference name", 
    },
    pinCode: {
        required : "Please provide pinCode", 
        invalid : "Please provide valid pin code", 
    },
    country: {
        required : "Please provide country name", 
        invalid : "Please provide valid country name", 
    },
    street: {
        required : "Please provide street name", 
        invalid : "Please provide valid street name", 
    },
    state: {
        required : "Please provide state name", 
        invalid : "Please provide valid state name", 
    },
    password: {
        required : "Please provide password", 
        invalid : "Please provide valid password", 
    },
    userRole: {
        required : "Please provide user role",
    },
    managerId: {
        required : "Please provide managerId",
    },
    accountId: {
        required : "Please provide account name",
    },
    leadType:{
        required : "Please provide lead type",
    },
    leadName:{
        required : "Please provide lead name",
        invalid : "Please provide valid lead name", 
    },
    customerType:{
        required : "Please provide customer type",
    },
    name:{
        required : "Please provide name",
        invalid : "Please provide valid name", 
    },
    gstNo:{
        required : "Please provide gst number",
        invalid : "Please provide valid gst number", 
    },
    quantity:{
        required : "Please provide quantity",
        invalid : "Please provide valid quantity", 
    },
    salePrice:{
        required : "Please provide Sale Price",
        invalid : "Please provide valid Sale Price", 
    },
    ownerId:{
        required : "Please provide assign user",
    },
    remarks:{
        required : "Please provide remark",
    },

    type:{
        required : "Please provide type", 
    },
    priority:{
        required : "Please provide priority", 
    },
    status:{
        required : "Please provide status", 
    },
    date:{
        required : "Please provide date", 
    },

    offerName:{
        required : "Please provide offer name",
        invalid: "Please provide valid offer name",
    },

    orderName:{
        required : "Please provide order",
        invalid: "Please provide valid order",
    },

    supplier:{
        required : "Please provide supplier",
    },
    customer:{
        required : "Please provide customer",
    },
    financialYear:{
        required : "Please Provide Financial Year",
    },
    branchName:{
        required : "Please provide Branch name",
        invalid :  "Please provide valid Branch name",
    },
    branchRefference:{
        required : "Please provide Branch Refference",
        invalid :  "Please provide valid Branch Refference",
    },
    productName: {
        required : "Please provide product name",
        invalid : "Please provide valid prouct name",
    },
    //comment by shahir hussain
    /* Added by shahir hussain for customer info
    servicesOffered: {
        required : "Please provide services offered",
        invalid : "Please provide valid services offered",
    },
    previousSalonServices: {
        required : "Please provide previous salon services",
        invalid : "Please provide valid previous salon services",
    },
    skinType: {
        required : "Please provide skin type",
        invalid : "Please provide valid skin type",
    },
    hairType: {
        required : "Please provide hair type",
        invalid : "Please provide valid hair type",
    },
    allergies: {
        required : "Please provide allergies",
        invalid : "Please provide valid allergies",
    },
    anniversary: {
        required : "Please provide anniversary",
        invalid : "Please provide valid anniversary",
    },
    previousExperience: {
        required : "Please provide Previous Experience",
        invalid : "Please provide valid Previous Experience",
    },*/
}